import React, { useEffect, useState, useContext } from 'react';
import ApiRequestV2 from '../../Common/hooks/ApiRequestV2';
import { useNavigate } from 'react-router-dom';
import { useAlert } from '../../Common/Context/AlertContext';
import { SalesRootContext } from '../../Common/Context/SalesRootContext';
import { useReservation } from '../../Common/Context/ReserveContextV2';
import Spinner from '../../Common/components/Spinner'

const SalesRootsV2 = () => {
    // APIリクエストのフックを使用してデータを取得
    const { response, error, isLoading, fetchData } = ApiRequestV2();
    // 選択された営業ルートを管理する状態
    const [selectedRoot, setSelectedRoot] = useState('');
    // ルーティングのためのフック
    const navigate = useNavigate();
    // アラート表示のためのフック
    const { showAlert } = useAlert();
    // セールスルートデータと予約情報を管理するコンテキスト
    const { setSalesRootData } = useContext(SalesRootContext);
    const { setIsReserved, setTempReserveInfo } = useReservation();

    // APIのエンドポイントURL
    const url = 'tlap/salesroot/display';

    // コンポーネントがマウントされたときにデータを取得
    useEffect(() => {
        fetchData(url);
    }, [fetchData, url]);

    // APIレスポンスを受け取ったときの処理
    useEffect(() => {
        if (response) {
            // console.log('API response received:', response);
            if (response.temp_reserve_info) {
                // 仮予約情報がある場合
                // console.log('Temporary reservation found:', response.temp_reserve_info);
                setIsReserved(true);
                setTempReserveInfo({
                    temp_sales_root: response.temp_reserve_info.temp_sales_root,
                    temp_appoint_date: response.temp_reserve_info.temp_appoint_date,
                });
                setSalesRootData({
                    company: response.company,
                    TLAP_id: response.TLAP_id,
                    TLAP_name: response.TLAP_name,
                    sales_root: response.sales_root,
                    group: response.group,
                    selectedRoot: response.temp_reserve_info.temp_sales_root,
                    tempReserveInfo: {
                        temp_sales_root: response.temp_reserve_info.temp_sales_root,
                        temp_appoint_date: response.temp_reserve_info.temp_appoint_date,
                    },
                });
                // カレンダーページに遷移
                navigate('/carendar');
            } else {
                // 仮予約情報がない場合
                // console.log('No temporary reservation found.');
                setSalesRootData({
                    company: response.company,
                    TLAP_id: response.TLAP_id,
                    TLAP_name: response.TLAP_name,
                    sales_root: response.sales_root,
                    group: response.group,
                    selectedRoot: '',
                    tempReserveInfo: null,
                });
            }
        }
    }, [response, setIsReserved, setTempReserveInfo, setSalesRootData, navigate]);
    
    // 更新ボタンが押されたときにデータを再取得
    const handleRefresh = () => {
        fetchData(url);
    };

    // フォームが送信されたときの処理
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!selectedRoot) {
            showAlert('営業ルートを選択してください。');
            return;
        }
        if (response) {
            setSalesRootData({
                company: response.company,
                TLAP_id: response.TLAP_id,
                TLAP_name: response.TLAP_name,
                sales_root: response.sales_root,
                group: response.group,
                selectedRoot,
                tempReserveInfo: null,
            });
            navigate('/carendar');
        }
    };



    if (isLoading) return <Spinner />;
    if (error) return <div>Error: {error}</div>;

    // 検索クエリに基づいて営業ルートをフィルタリングし、アルファベット順に並び替え
    const filteredSalesRoots = response?.sales_root
        // ?.filter(root => root.toLowerCase().includes(searchQuery.toLowerCase())) // フィルタリング
        .sort(); // 並び替え
        return (
            <div className='wrapper2 salesRoots'>
                <div className='helloUser'>
                    <h1>おはようございます、{response?.TLAP_name}さん！</h1>
                    <p>本日も一緒に、元気に頑張りましょう！</p>
                </div>
                <button onClick={handleRefresh} className='backBtn buttonStyle'>更新</button>
    
                <h2>営業ルートを選んでください</h2>
    
    
                <form onSubmit={handleSubmit}>
                    {filteredSalesRoots?.map((root, index) => (
                        <label key={index} className='salesroot_select'>
                            <input
                                type="radio"
                                id={root}
                                name="salesRoot"
                                value={root}
                                onChange={(e) => setSelectedRoot(e.target.value)}
                                checked={selectedRoot === root}
                                style={{ marginRight: '10px' }}
                            />
                            {root}
                        </label>
                    ))}
                    <button className='ConfirmBtn buttonStyle' type="submit">確定</button>
                </form>
            </div>
        );
    };
    
    export default SalesRootsV2;